(function() { window.GUID_795f4975_a05a_4589_abfb_48b714615a47 = { getGuid: function() { return "795f4975-a05a-4589-abfb-48b714615a47"; } }; })();
var CS;
(function (CS) {
    class TimePicker {
        constructor(input) {
            this.SelectionChange = null;
            this.TimePickerId = input[0].id;
            this.Lang = CSParameters.Language;
            this.setFormat();
            this.Input = $(input[0]);
            this.Input.data('context', this);
            this.HiddenInput = $("#" + this.TimePickerId + "Hidden");
            this.CreatePopup();
            this.Prepare();
        }
        val(newVal) {
            console.log(newVal);
            if (newVal != null) {
                let newValTime;
                if (typeof newVal === 'string' || newVal instanceof String)
                    newValTime = this.ParseValue(newVal);
                else
                    newValTime = newVal;
                this.ActualTime = newValTime;
                this.ShowTime();
                this.Input.trigger('blur');
                return this.Input.val();
            }
            else {
                return this.HiddenInput.val();
            }
        }
        setFormat() {
            this.HiddenFormat = new Intl.DateTimeFormat("en", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
                timeZone: "UTC"
            });
            switch (this.Lang) {
                case "en":
                    this.Format = new Intl.DateTimeFormat("en", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                        timeZone: "UTC"
                    });
                    break;
                case "fr":
                    this.Format = new Intl.DateTimeFormat("en", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                        timeZone: "UTC"
                    });
                    break;
                case "es":
                    this.Format = new Intl.DateTimeFormat("en", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                        timeZone: "UTC"
                    });
                    break;
                case "fi":
                    this.Format = new Intl.DateTimeFormat("en", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                        timeZone: "UTC"
                    });
                    break;
                default:
                    this.Format = new Intl.DateTimeFormat("en", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                        timeZone: "UTC"
                    });
            }
        }
        CreatePopup() {
            let me = this;
            let pop = $('<div>');
            let html = "";
            if (me.Lang == "fr" || me.Lang == 'fi') {
                html = '<div class="CSTimePickerPopup" data-lang="fr"><div class="Time"><div class="Hour"><p>AM</p><ul class="HourAM"><li data-val="00">00</li><li data-val="1">01</li><li data-val="2">02</li><li data-val="3">03</li><li data-val="4">04</li><li data-val="5">05</li><li data-val="6">06</li><li data-val="7">07</li><li data-val="8">08</li><li data-val="9">09</li><li data-val="10">10</li><li data-val="11">11</li></ul><p>PM</p><ul class="HourPM"><li data-val="12">12</li><li data-val="13">13</li><li data-val="14">14</li><li data-val="15">15</li><li data-val="16">16</li><li data-val="17">17</li><li data-val="18">18</li><li data-val="19">19</li><li data-val="20">20</li><li data-val="21">21</li><li data-val="22">22</li><li data-val="23">23</li></ul></div><div class="Minute"><p>Minute</p><ul><li>00</li><li>05</li><li>10</li><li>15</li><li>20</li><li>25</li><li>30</li><li>35</li><li>40</li><li>45</li><li>50</li><li>55</li></ul>';
            }
            else {
                html = '<div class="CSTimePickerPopup" data-lang="en"><div class="Time"><div class="Hour"><p>AM</p><ul class="HourAM"><li data-val="00">12</li><li data-val="1">01</li><li data-val="2">02</li><li data-val="3">03</li><li data-val="4">04</li><li data-val="5">05</li><li data-val="6">06</li><li data-val="7">07</li><li data-val="8">08</li><li data-val="9">09</li><li data-val="10">10</li><li data-val="11">11</li></ul><p>PM</p><ul class="HourPM"><li data-val="12">12</li><li data-val="13">01</li><li data-val="14">02</li><li data-val="15">03</li><li data-val="16">04</li><li data-val="17">05</li><li data-val="18">06</li><li data-val="19">07</li><li data-val="20">08</li><li data-val="21">09</li><li data-val="22">10</li><li data-val="23">11</li></ul></div><div class="Minute"><p>Minute</p><ul><li>00</li><li>05</li><li>10</li><li>15</li><li>20</li><li>25</li><li>30</li><li>35</li><li>40</li><li>45</li><li>50</li><li>55</li></ul>';
            }
            pop.append(html);
            //var parent = $(me.Input).parent();
            //pop.appendTo(parent);
            pop.appendTo($('body'));
            me.List = $('.Time', pop);
            me.Popup = $('.CSTimePickerPopup', pop);
        }
        Prepare() {
            let me = this;
            this.ActualTime = this.ParseValue(this.HiddenInput.val());
            this.BeforeChangeValue = this.SnapshotActualTime();
            this.ShowTime();
            this.List.on('mousedown', '.Hour li', function (e) {
                let li = e.currentTarget;
                let val = $(li).data("val");
                me.UpdateHourValue(val);
                e.preventDefault();
                me.RefreshHighlighted();
            });
            this.List.on('mousedown', '.Minute li', function (e) {
                var li = e.currentTarget;
                var val = $(li).html();
                me.UpdateMinuteValue(Number(val));
                e.preventDefault();
                me.RefreshHighlighted();
                me.Input.trigger('blur');
            });
            this.Input.on('click', function (e) {
                me.Popup.css('left', e.clientX + 'px');
                me.Popup.css('top', e.clientY + 'px');
                me.RefreshHighlighted();
                me.BeforeChangeValue = me.SnapshotActualTime();
                me.Popup.slideDown(150, function () { me.Show(); });
            }).on('focus', function (e) {
                me.BeforeChangeValue = me.SnapshotActualTime();
            }).on('blur', function (e) {
                me.Popup.slideUp(150, function () {
                    me.Hide();
                });
                if (me.Input.val() != me.Format.format(me.ActualTime) && me.IsReadable()) {
                    const time = me.ReadTime();
                    me.UpdateHourValue(time.getUTCHours());
                    me.UpdateMinuteValue(time.getUTCMinutes());
                }
                if (me.BeforeChangeValue.getTime() != me.ActualTime.getTime()) {
                    if (me.SelectionChange != null) {
                        me.SelectionChange.call(me);
                    }
                    me.Input.trigger("CSChange", me);
                    if (me.EventToTrigger != "" && me.EventToTrigger != null) {
                        me.Input.trigger(me.EventToTrigger, me);
                    }
                    me.BeforeChangeValue = me.SnapshotActualTime();
                }
            }).on('keyup', function (e) {
                if (e.keyCode == 13) {
                    me.Input.trigger('blur');
                }
                else {
                    me.RefreshHighlighted(me.ReadTime());
                }
            });
        }
        SnapshotActualTime() {
            return new Date(this.ActualTime.getTime());
        }
        RefreshHighlighted(time = this.ActualTime) {
            let hour = time.getUTCHours();
            let minute = time.getUTCMinutes();
            let hoursAM = $('.Hour .HourAM li', this.List);
            let hoursPM = $('.Hour .HourPM li', this.List);
            let minutes = $('.Minute li', this.List);
            $.each(hoursAM, function (index, li) {
                let item = $(li);
                if (item.data("val") == hour) {
                    item.addClass('IsHighlighted');
                }
                else {
                    item.removeClass('IsHighlighted');
                }
            });
            $.each(hoursPM, function (index, li) {
                let item = $(li);
                if (item.data("val") == hour) {
                    item.addClass('IsHighlighted');
                }
                else {
                    item.removeClass('IsHighlighted');
                }
            });
            $.each(minutes, function (index, li) {
                let item = $(li);
                if (Number(item.html()) == minute) {
                    item.addClass('IsHighlighted');
                }
                else {
                    item.removeClass('IsHighlighted');
                }
            });
        }
        UpdateHourValue(newValue) {
            this.ActualTime.setUTCHours(newValue);
            this.WriteToHiddenValue(this.ActualTime);
            this.ShowTime();
        }
        UpdateMinuteValue(newValue) {
            this.ActualTime.setUTCMinutes(newValue);
            this.WriteToHiddenValue(this.ActualTime);
            this.ShowTime();
        }
        Show() {
        }
        Hide() {
        }
        ReadHourValue() {
            let val = this.Input.val();
            let result = "0";
            if (val.indexOf(':') > -1) {
                let split = val.split(":");
                if (split.length > 0) {
                    result = split[0];
                }
            }
            return Number(result);
        }
        ReadMinuteValue() {
            let val = this.Input.val();
            let result = "0";
            if (val.indexOf(':') > -1) {
                let split = val.split(":");
                if (split.length > 1) {
                    result = split[1].substr(0, 2);
                }
            }
            return Number(result);
        }
        ReadIsPM() {
            let val = this.Input.val();
            if (this.Lang == "en" || this.Lang == "es") {
                if (val.toUpperCase().indexOf('PM') > -1) {
                    return true;
                }
                return false;
            }
            else {
                if (this.ReadHourValue() >= 12) {
                    return true;
                }
                return false;
            }
        }
        ReadTime() {
            const hours = this.ReadHourValue();
            const minutes = this.ReadMinuteValue();
            const isPM = this.ReadIsPM();
            let resultTime = new Date(Date.UTC(1, 1, 1, 0, 0, 0, 0));
            if (!isNaN(hours)) {
                if ((this.Lang == "en" || this.Lang == "es") && isPM) {
                    resultTime.setUTCHours(hours + 12);
                }
                else {
                    resultTime.setUTCHours(hours);
                }
            }
            if (!isNaN(minutes)) {
                resultTime.setUTCMinutes(minutes);
            }
            return resultTime;
        }
        IsReadable() {
            const hours = this.ReadHourValue();
            const minutes = this.ReadMinuteValue();
            return (!isNaN(hours) && !isNaN(minutes));
        }
        ParseValue(value) {
            const timeString = value;
            const hours = Number(timeString.substring(11, 13));
            const minutes = Number(timeString.substring(14, 16));
            let resultTime = new Date(Date.UTC(1, 1, 1, 0, 0, 0, 0));
            if (!isNaN(hours) && !isNaN(minutes)) {
                resultTime.setUTCHours(hours);
                resultTime.setUTCMinutes(minutes);
            }
            return resultTime;
        }
        WriteToHiddenValue(date) {
            this.HiddenInput.val(date.toISOString().replace('T', ' ').substring(0, 19));
        }
        ShowTime() {
            this.Input.val(this.Format.format(this.ActualTime));
            //this.Input.val(this.ActualTime.toLocaleTimeString(this.Lang, { timeZone: "UTC" }));
        }
    }
    CS.TimePicker = TimePicker;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSTimePicker = function () {
        this.each(function () {
            var timePicker = new CS.TimePicker($(this));

            //Donne access au datepicker de n'importe quels scripts.
            eval('document.' + timePicker.TimePickerId + '=timePicker;');
        });
    };
})(jQuery);


var CS = CS || {};

CS.TimePicker = function (me) {
    this.TimePickerId = me[0].id;
    this.Lang = CSParameters.Language;
    this.SelectionChange = null;
    this.val = function (newVal) {
        if (newVal != null) {
            this.Input.val(newVal);
            this.Input.trigger('blur');
            return this.Input.val();
        }
        else
            return this.Input.val();
    };
    this.Input = $(me[0]);
    this.Input.data('context', this);
    this.CreatePopup();
    this.BeforeChangeValue = "";
    this.Prepare();
};

CS.TimePicker.prototype = function () {

    var CreatePopup = function () {
        var me = this;
        var pop = $('<div>');
        var html = "";
        if (me.Lang == "fr" || me.Lang == 'fi') {
            html = '<div class="CSTimePickerPopup" data-lang="fr"><div class="Time"><div class="Hour"><p>AM</p><ul class="HourAM"><li data-val="00">00</li><li data-val="1">01</li><li data-val="2">02</li><li data-val="3">03</li><li data-val="4">04</li><li data-val="5">05</li><li data-val="6">06</li><li data-val="7">07</li><li data-val="8">08</li><li data-val="9">09</li><li data-val="10">10</li><li data-val="11">11</li></ul><p>PM</p><ul class="HourPM"><li data-val="12">12</li><li data-val="13">13</li><li data-val="14">14</li><li data-val="15">15</li><li data-val="16">16</li><li data-val="17">17</li><li data-val="18">18</li><li data-val="19">19</li><li data-val="20">20</li><li data-val="21">21</li><li data-val="22">22</li><li data-val="23">23</li></ul></div><div class="Minute"><p>Minute</p><ul><li>00</li><li>05</li><li>10</li><li>15</li><li>20</li><li>25</li><li>30</li><li>35</li><li>40</li><li>45</li><li>50</li><li>55</li></ul>';
        }
        else {
            html = '<div class="CSTimePickerPopup" data-lang="en"><div class="Time"><div class="Hour"><p>AM</p><ul class="HourAM"><li data-val="00">12</li><li data-val="1">01</li><li data-val="2">02</li><li data-val="3">03</li><li data-val="4">04</li><li data-val="5">05</li><li data-val="6">06</li><li data-val="7">07</li><li data-val="8">08</li><li data-val="9">09</li><li data-val="10">10</li><li data-val="11">11</li></ul><p>PM</p><ul class="HourPM"><li data-val="12">12</li><li data-val="13">01</li><li data-val="14">02</li><li data-val="15">03</li><li data-val="16">04</li><li data-val="17">05</li><li data-val="18">06</li><li data-val="19">07</li><li data-val="20">08</li><li data-val="21">09</li><li data-val="22">10</li><li data-val="23">11</li></ul></div><div class="Minute"><p>Minute</p><ul><li>00</li><li>05</li><li>10</li><li>15</li><li>20</li><li>25</li><li>30</li><li>35</li><li>40</li><li>45</li><li>50</li><li>55</li></ul>';
        }

        pop.append(html);

        //var parent = $(me.Input).parent();
        //pop.appendTo(parent);

        pop.appendTo($('body'));

        me.List = $('.Time', pop);

        me.Popup = $('.CSTimePickerPopup', pop);

    },
    Prepare = function () {
        var me = this;

        this.List.on('mousedown', '.Hour li', function (e) {
            var li = e.currentTarget;
            var am = $(li).parent().hasClass('HourAM');
            var val = $(li).html();
            me.UpdateHourValue(val, am);
            e.preventDefault();
            me.RefreshHighlighted();
        });
        this.List.on('mousedown', '.Minute li', function (e) {
            var li = e.currentTarget;
            var val = $(li).html();
            me.UpdateMinuteValue(val);
            e.preventDefault();
            me.RefreshHighlighted();
            me.Input.trigger('blur');
        });
        this.Input.on('click', function (e) {
            me.Popup.css('left', e.clientX + 'px');
            me.Popup.css('top', e.clientY + 'px');

            me.RefreshHighlighted();
            me.BeforeChangeValue = me.Input.val();
            me.Popup.slideDown(150, function () { me.Show(); });
        }).on('focus', function (e) {
            me.BeforeChangeValue = me.Input.val();
        }).on('blur', function (e) {
            me.Popup.slideUp(150, function () {
                me.Hide();
            });
            if (me.BeforeChangeValue != me.Input.val()) {
                if (me.SelectionChange != null)
                    me.SelectionChange.call(me);

                me.Input.trigger("CSChange", me);

                me.BeforeChangeValue = me.Input.val();
            }
        }).on('keyup', function (e) {
            if (e.keyCode == "13") {
                me.Input.trigger('blur');
            }
            else {
                me.RefreshHighlighted();
            }
        });
    },
    RefreshHighlighted = function () {
        var hour = this.GetHourValue();
        var minute = this.GetMinuteValue();
        var isAM = this.IsAM();

        var hoursAM = $('.Hour .HourAM li', this.List);
        var hoursPM = $('.Hour .HourPM li', this.List);

        var minutes = $('.Minute li', this.List);

        $.each(hoursAM, function (index, li) {
            var item = $(li);
            if (isAM) {
                if (item.html() == hour) {
                    item.addClass('IsHighlighted');
                }
                else {
                    item.removeClass('IsHighlighted');
                }
            }
            else {
                item.removeClass('IsHighlighted');
            }
        });
        $.each(hoursPM, function (index, li) {
            var item = $(li);
            if (!isAM) {
                if (item.html() == hour) {
                    item.addClass('IsHighlighted');
                }
                else {
                    item.removeClass('IsHighlighted');
                }
            }
            else {
                item.removeClass('IsHighlighted');
            }
        });
        $.each(minutes, function (index, li) {
            var item = $(li);
            if (item.html() == minute) {
                item.addClass('IsHighlighted');
            }
            else {
                item.removeClass('IsHighlighted');
            }
        });
    },
    GetHourValue = function () {
        var val = this.Input.val();
        if (val.indexOf(':') > -1) {
            var split = val.split(":");
            if (split.length > 0) {
                if (split[0].length == 1) {
                    return "0" + split[0];
                }
                else {
                    return split[0];
                }
            }
        }
        return "00";
    },
    GetMinuteValue = function () {
        var val = this.Input.val();
        if (val.indexOf(':') > -1) {
            var split = val.split(":");
            if (split.length > 1) {
                return split[1].substr(0, 2);
            }
        }
        return "00";
    },
    IsAM = function () {
        var val = this.Input.val();
        if (this.Lang == "en") {
            if (val.toUpperCase().indexOf('AM') > -1) {
                return true;
            }
            return false;
        }
        else {
            if (this.GetHourValue() < 12) {
                return true;
            }
            return false;
        }
    },
    GetTimeValue = function () {
        var hour = this.GetHourValue();
        var minute = this.GetMinuteValue();

        if (this.Lang == "en") {
            if (this.IsAM()) {
                return hour + ":" + minute + " AM";
            }
            else {
                return hour + ":" + minute + " PM";
            }
        }
        else {
            return hour + ":" + minute;
        }
    },
    UpdateHourValue = function (newValue, am) {
        var actualHour = this.GetHourValue();
        var actualTime = this.GetTimeValue();
        var suffix = "";

        actualTime = actualTime.replace(actualHour + ":", newValue + ":");

        if (this.Lang == "en") {
            if (am) {
                actualTime = actualTime.replace("PM", "AM");
            }
            else {
                actualTime = actualTime.replace("AM", "PM");
            }
        }

        this.Input.val(actualTime);
    },
    UpdateMinuteValue = function (newValue) {
        var actualMinute = this.GetMinuteValue();
        var actualTime = this.GetTimeValue();

        actualTime = actualTime.replace(":" + actualMinute, ":" + newValue);
        this.Input.val(actualTime);
    },
    Show = function () {

    },
    Hide = function () {

    };
    return {
        Prepare: Prepare,
        CreatePopup: CreatePopup,
        GetHourValue: GetHourValue,
        GetMinuteValue: GetMinuteValue,
        GetTimeValue: GetTimeValue,
        UpdateHourValue: UpdateHourValue,
        UpdateMinuteValue: UpdateMinuteValue,
        RefreshHighlighted: RefreshHighlighted,
        IsAM: IsAM,
        Show: Show,
        Hide: Hide
    };

}();
*/ 

//# sourceMappingURL=cs.timepicker.js.map
